import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { infDb } from "../firebase-inf";


import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import TermsModal from "../components/TermsModal";
import { Crown } from "lucide-react";

const InfluencerDetail = () => {
  const { id } = useParams();
  const [influencer, setInfluencer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Fetches influencer details from the Firestore database using the provided ID.
 * Sets the influencer state with the fetched data if the document exists.
 * If the document does not exist, sets an error message indicating the influencer is not found.

/*******  a5fc0a8a-bd42-4d27-9a33-82f2aef7bc56  *******/
    const fetchInfluencer = async () => {
      try {
       const docRef = doc(infDb, "influencers", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setInfluencer(docSnap.data());
        } else {
          setError("Influencer not found.");
        }
      } catch (err) {
        console.error("Error fetching influencer:", err);
        setError("Failed to load influencer details.");
      } finally {
        setLoading(false);
      }
    };

    fetchInfluencer();
  }, [id]);

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error) return <div className="text-center mt-10 text-red-500">{error}</div>;

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />

      <div className="flex flex-col flex-1 overflow-y-auto bg-gray-50">
        <Header />

        <main className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Left Column – Modernized Influencer Info */}
          <div className="bg-gradient-to-br from-white via-gray-50 to-white p-6 rounded-2xl shadow-lg border border-gray-200">
            <div className="flex flex-col items-center mb-6">
                <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-purple-200 shadow-md">
               <img
  src={influencer.images?.[0]}
  alt={influencer.name}
  className="w-full h-full object-contain"
/>
                </div>
            </div>

            <div className="space-y-4 px-2">
                <h2 className="text-2xl font-bold text-blue-600">
                <a
                    href={`https://instagram.com/${influencer.instagram}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                >
                    @{influencer.instagram}
                </a>
                </h2>

                <p className="text-lg text-gray-800">
                <span className="font-semibold">Name:</span> {influencer.name}
                </p>
                <p className="text-lg text-gray-800">
                <span className="font-semibold">Email:</span> {influencer.email}
                </p>
                <p className="text-lg text-gray-800">
                <span className="font-semibold">Categories:</span> {influencer.category?.join(", ")}
                </p>
             <div className="space-y-2">
  <h4 className="text-lg font-semibold text-gray-800">Selected Package(s):</h4>
  {influencer.packages?.length > 0 ? (
    influencer.packages.map((pkg, index) => (
      <div key={index} className="border p-3 rounded bg-gray-100">
        <p className="text-sm font-semibold text-purple-800">{pkg.name}</p>
        <p className="text-sm text-gray-700">{pkg.description}</p>
        <p className="text-sm text-gray-800">
          Price: ₹{pkg.price}
        </p>
      </div>
    ))
  ) : (
    <p className="text-sm text-gray-600">No package selected.</p>
  )}
</div>



               <p
  className="text-base text-gray-600 pt-2 cursor-pointer hover:text-green-600 transition"
  onClick={() => window.open("https://wa.me/919717990863", "_blank")}
>
  Contact our team to hire an influencer now.
</p>

            </div>
            </div>

          {/* Right Column – Locked Images */}
         <div className="bg-white p-6 rounded-lg shadow">
  <h3 className="text-lg font-semibold mb-4">Model Images</h3>
  {influencer.images && influencer.images.length > 0 ? (
    <div className="grid grid-cols-2 gap-4">
     {influencer.images.map((img, idx) => (
        <div key={idx} className="relative group">
          <img
            src={img}
            alt={`Model ${idx + 1}`}
            className="w-full h-40 object-cover filter blur-sm group-hover:blur-sm rounded"
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <Crown className="text-yellow-500 w-10 h-10" />
          </div>
        </div>
      ))}
    </div>
  ) : (
    <p className="text-gray-500">No model images available.</p>
  )}
</div>


          {/* Bottom Section – T&C and Back Button */}
          <div className="md:col-span-2 mt-6">
            <p className="text-sm text-gray-600">
              By proceeding, you agree to our{" "}
              <button
                onClick={() => setIsModalOpen(true)}
                className="text-blue-600 underline"
              >
                Terms & Conditions
              </button>.
            </p>

            <TermsModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

            <button
              className="mt-4 bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-6 rounded"
              onClick={() => window.history.back()}
            >
              Back
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default InfluencerDetail;
